import React from "react";
import Rightmenu from "./Rightmenu/Rightmenu";
import Leftpost from "./Leftpost";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import LocalsPost from "./LocalsPost";

function Mainpost() {

    return(
        <div>
            <Container style={{marginTop:'30px'}}>
                <Row>
                    <Col xs={8}><LocalsPost></LocalsPost></Col>
                    <Col xs={4}><Rightmenu></Rightmenu></Col>
                </Row>
            </Container>
        </div>
    )

}
export default Mainpost